import ApiService from '@/services/api';

// TYPES

export type TLicensePriceResponse = {
  /** Base license, in the smallest currency unit: 180000 means EUR 1800.00. */
  base_amount: number;
  /** One additional user account, same unit. */
  extra_seat_amount: number;
  /** ISO currency code, upper case. */
  currency: string;
  /** Seats the base license already covers. */
  included_seats: number;
  interval: string;
};

/**
 * Reads both prices from Stripe via our backend, so the quoted total always
 * matches what the customer is actually charged.
 */
export const getLicensePrice = async (): Promise<TLicensePriceResponse> => {
  const response = await ApiService.get('/v1/licenses/price/');
  return response?.data;
};
